// extracted by mini-css-extract-plugin
export default {"containerwrap":"ResetPassword_containerwrap__gFLsR","form_container":"ResetPassword_form_container__SGepL","left":"ResetPassword_left__XKj3H","right":"ResetPassword_right__DwkKu"};